import { useEffect, useState } from "react";
import { api, useAuth } from "@/lib/auth";
import { usePageMeta } from "@/hooks/usePageMeta";
import { PortalShell } from "@/components/account/PortalShell";
import { StaffPanel, useElevation } from "@/components/noxn/AdminShared";
import { Users } from "lucide-react";

export default function StaffManagement() {
    usePageMeta({ title: "Staff management · NOXN", description: "Create, suspend and manage staff accounts." });
    const { user } = useAuth();
    const [access, setAccess] = useState(null);
    const { withElevation, elevateUI } = useElevation();

    useEffect(() => {
        api.get("/admin/my-access").then(({ data }) => setAccess(data)).catch(() => setAccess({ permissions: [] }));
    }, []);

    const can = (p) => access?.permissions?.includes(p);

    return (
        <PortalShell title="Staff" mainClassName="p-0">
        <div className="min-h-screen bg-[#0F1E3B] text-white" data-testid="staff-management-page">
            <main className="mx-auto max-w-6xl px-6 lg:px-10 py-10">
                <div className="flex items-center gap-2 mb-2">
                    <Users size={16} className="text-[#FF5A00]" />
                    <span className="font-mono-tech text-[10px] uppercase tracking-[0.35em] text-slate-400">
                        {access ? `Signed in as ${access.role}` : "…"}
                    </span>
                </div>
                <h1 className="font-display font-black tracking-tighter text-4xl">Staff management.</h1>
                <p className="mt-3 max-w-xl text-slate-400 text-sm">
                    Create accounts, set roles, suspend or remove staff, and impersonate for support — all actions are audit-logged.
                </p>
                <div className="mt-10">
                    <StaffPanel can={can} withElevation={withElevation} meId={user?.id} />
                </div>
            </main>
            {elevateUI}
        </div>
        </PortalShell>
    );
}
